import type {
  CurityCredentials,
  GenerateCurityLogoutUrlOptions,
  GenerateCurityUrlOptions,
  TokenResponse,
} from './types';

const POSSIBLE_CHARS =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export const generateRandomString = (length: number): string => {
  const randomValues = new Uint8Array(length);
  crypto.getRandomValues(randomValues);

  return Array.from(randomValues, (byte) =>
    POSSIBLE_CHARS.charAt(byte % POSSIBLE_CHARS.length)
  ).join('');
};

export const generateCurityUrl = (options: GenerateCurityUrlOptions): string => {
  const {
    redirectUri,
    codeChallenge,
    clientId,
    oauthBaseUrl,
    uiLocale = 'en',
    state,
    nonce,
  } = options;

  if (!oauthBaseUrl) {
    throw new Error('Missing OAUTH_BASE_URL');
  }
  const queryParams = new URLSearchParams({
    client_id: clientId,
    response_type: 'code',
    redirect_uri: redirectUri,
    scope: 'openid school profile',
    code_challenge: codeChallenge,
    code_challenge_method: 'S256',
    ui_locales: uiLocale,
  });

  if (state) {
    queryParams.set('state', state);
  }

  if (nonce) {
    queryParams.set('nonce', nonce);
  }

  return `${oauthBaseUrl}/oauth-authorize?${queryParams}`;
};

export const generateCurityLogoutUrl = (options: GenerateCurityLogoutUrlOptions): string => {
  const { clientId, oauthBaseUrl, idToken, redirectUri } = options;

  if (!oauthBaseUrl) {
    throw new Error('Missing OAUTH_BASE_URL');
  }

  const queryParams = new URLSearchParams({
    id_token_hint: idToken,
    client_id: clientId,
  });

  if (redirectUri) {
    queryParams.append('post_logout_redirect_uri', redirectUri);
  }

  return `${oauthBaseUrl}/oauth-session/logout?${queryParams}`;
};

export type { CurityCredentials, TokenResponse };

